import { Injectable } from "@angular/core";
import {
    HttpClient,
    HttpErrorResponse,
    HttpHeaders,
    HttpParams,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { AppSetting } from "../services/appsetting";
import { AuthGuard } from "../guard/auth.guard";
import CryptoJS from "crypto-js";
import "rxjs/add/operator/map";
import "rxjs/add/operator/toPromise";
import { Router } from "@angular/router";
@Injectable()
export class AppService {
    private url: string;
    key: any = "0123456789abcdef0123456789abcdef";
    public pending: boolean = false;
    iterations: any = 999;
    iv: any;
    salt: any;
    encryptMethodLength: any;
    hashKey: any;
    output: any;
    user_code = "";
    constructor(
        private http: HttpClient,
        private router: Router,
        private authGuard: AuthGuard,
    ) {
        this.iv = CryptoJS.lib.WordArray.random(16);
        this.salt = CryptoJS.lib.WordArray.random(256);
        let encryptMethod = "AES-256-CBC";
        let aesNumber = encryptMethod.match(/\d+/)[0];
        this.encryptMethodLength = parseInt(aesNumber) / 4;
        this.hashKey = CryptoJS.PBKDF2(this.key, this.salt, {
            hasher: CryptoJS.algo.SHA512,
            keySize: this.encryptMethodLength / 8,
            iterations: this.iterations,
        });
        this.output = {
            // 'ciphertext': encryptedString,
            iv: CryptoJS.enc.Hex.stringify(this.iv),
            salt: CryptoJS.enc.Hex.stringify(this.salt),
            iterations: this.iterations,
        };
    }
    httpCall(_ad: any, _fd: any): any {
        let user_code = "";
        let role_code = "";
        if (localStorage.getItem("userData")) {
            let user = JSON.parse(localStorage.getItem("userData"));
            user_code = user.user_code;
            role_code = user.role_code;
        }
        let action: string = _ad.action;

        this.url = AppSetting.API_ENDPOINT + action;
        const headers = new HttpHeaders()
            .set("Authorization", "auth-token")
            .set("version", "v1.2")
            .set("usercode", user_code)
            .set("rolecode", role_code);
        return this.http
            .post<any>(this.url, _fd, {
                observe: "body",
                headers,
                responseType: "text" as "json",
            })
            .map(
                (data: any) => {
                    let json = JSON.parse(
                        CryptoJS.enc.Utf8.stringify(
                            CryptoJS.enc.Base64.parse(data),
                        ),
                    );
                    let salt = CryptoJS.enc.Hex.parse(json.salt);
                    let iv = CryptoJS.enc.Hex.parse(json.iv);
                    let encrypted = json.ciphertext; // no need to base64 decode.
                    let hashKey = CryptoJS.PBKDF2(this.key, salt, {
                        hasher: CryptoJS.algo.SHA512,
                        keySize: this.encryptMethodLength / 8,
                        iterations: this.iterations,
                    });
                    let decrypted = CryptoJS.AES.decrypt(encrypted, hashKey, {
                        mode: CryptoJS.mode.CBC,
                        iv: iv,
                    });
                    let result = decrypted.toString(CryptoJS.enc.Utf8);
                    let resultData = <any>JSON.parse(result);
                    if (resultData.responseData == "logout") {
                        localStorage.removeItem("isLoggedin");
                        localStorage.removeItem("api_key");
                        localStorage.removeItem("push_token");
                        localStorage.removeItem("userData");
                        this.router.navigate(["login"]);
                    }
                    // return data;
                    return resultData;
                },
                (error: HttpErrorResponse) => {
                    return Observable.throw(error.message || error);
                },
            );
    }

    httpSearchCall(_ad: any, _fd: any): any {
        let user_code = "";
        let role_code = "";
        if (localStorage.getItem("userData")) {
            let user = JSON.parse(localStorage.getItem("userData"));
            user_code = user.user_code;
            role_code = user.role_code;
        }
        let action: string = _ad.action;
        this.url = AppSetting.API_ENDPOINT + action;
        const headers = new HttpHeaders()
            .set("Authorization", "auth-token")
            // .set('version', 'v1.2')
            .set("usercode", user_code)
            .set("rolecode", role_code);
        return this.http.post<any>(this.url, _fd, { headers }).map(
            (data: Response) => {
                return data;
            },
            (error: HttpErrorResponse) => {
                return Observable.throw(error.message || error);
            },
        );
    }

    encrypt(string, callback) {
        let encrypted = CryptoJS.AES.encrypt(string, this.hashKey, {
            mode: CryptoJS.mode.CBC,
            iv: this.iv,
        });
        let encryptedString = CryptoJS.enc.Base64.stringify(
            encrypted.ciphertext,
        );
        this.output.ciphertext = encryptedString;
        callback(
            CryptoJS.enc.Base64.stringify(
                CryptoJS.enc.Utf8.parse(JSON.stringify(this.output)),
            ),
        );
    }
    async resetRequestFormData(fd: any, callback) {
        fd.forEach((val, key) => {
            this.encrypt(val, (result) => {
                fd.set(key, result);
            });
        });
        await callback(fd);
    }

    getUrlPdfViewer(pdfLink) {
        return this.http.get<ArrayBuffer>(pdfLink, {
            responseType: "arraybuffer" as "json",
        });
    }

    downloadFile(fileUrl: string) {
        return this.http.get(fileUrl, {
            observe: "body",
            responseType: "blob" as "json",
        });
    }

    httpCallWithFile(_ad: any, _fd: FormData): Observable<any> {
        let user_code = "";
        let role_code = "";
        if (localStorage.getItem("userData")) {
            let user = JSON.parse(localStorage.getItem("userData"));
            user_code = user.user_code;
            role_code = user.role_code;
        }

        let action: string = _ad.action;
        this.url = AppSetting.API_ENDPOINT + action;

        // No 'version: v1.2' → middleware skips decrypt on request
        // → backend returns plain JSON response (not encrypted)
        const headers = new HttpHeaders()
            .set("Authorization", "auth-token")
            .set("usercode", user_code)
            .set("rolecode", role_code);

        return this.http.post<any>(this.url, _fd, { headers }).map(
            (data: any) => {
                // Response is plain JSON — no decryption needed
                if (data && data.responseData == "logout") {
                    localStorage.removeItem("isLoggedin");
                    localStorage.removeItem("api_key");
                    localStorage.removeItem("push_token");
                    localStorage.removeItem("userData");
                    this.router.navigate(["login"]);
                }
                return data;
            },
            (error: HttpErrorResponse) => {
                return Observable.throw(error.message || error);
            },
        );
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2455195120/src/src/app/shared/services/index.ts